import { render, staticRenderFns } from "./bo-variable-suggest.vue?vue&type=template&id=516f24b5"
import script from "./bo-variable-suggest.vue?vue&type=script&lang=js"
export * from "./bo-variable-suggest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports